// extracted by mini-css-extract-plugin
export default {"form":"FormChangePassword_form__Xpsjk"};